import { request } from "@/utils/request"

export function orderSeedingJob(data) {
    return request({
        url: "api/advertising/youtube/create",
        method: "post",
        data
    })
}
export function getListJobOrder(param = null) {
    return request({
        url: "api/advertising/youtube/list" + (param ? param : ""),
        method: "get"
    })
}

export function removeOrder(data) {
    return request({
        url: "api/advertising/youtube/remove",
        method: "post",
        data
    })
}
export function checkInfoJobYoutube(data) {
    return request({
        url: "api/advertising/youtube/check-info",
        method: "post",
        data
    })
}
export function checkInfoJobYoutubeNew(data) {
    return request({
        url: "api/advertising/youtube/check-info",
        method: "post",
        data
    })
}
